import React from 'react'
import { SVGIconProps } from '../types'
const SvgArrowForwardIos = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M5.88 4.12 13.76 12l-7.88 7.88L8 22l10-10L8 2z" />
  </svg>
)
export default SvgArrowForwardIos
